import React, { FC, memo } from 'react'
import { Card, Title, Input } from 'components/common'

type Props = {
  estimateNumber: string
  setEstimateNumber: React.Dispatch<React.SetStateAction<string>>
}

const EstimateInfoCard: FC<Props> = (props) => {
  const { estimateNumber, setEstimateNumber } = props

  return (
    <Card shadow>
      <div className="mb-8">
        <Title level={5}>見積書情報</Title>
        <div>見積書番号</div>
        <div className="w-1/2">
          <Input
            placeholder="例）E2301001-01"
            value={estimateNumber}
            onChange={(event) => setEstimateNumber(event.target.value)}
            min={11}
            max={11}
          />
        </div>
      </div>
    </Card>
  )
}

export default memo(EstimateInfoCard)
